import { render, staticRenderFns } from "./OperationTypeInfo.vue?vue&type=template&id=4c5aa12d&"
import script from "./OperationTypeInfo.vue?vue&type=script&lang=js&"
export * from "./OperationTypeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports